__webpack_require__.p = "/c2c_ui/pwa-foundation/";